export const SAVE_DRAFT_FORM = 'jora-employer/draft/SAVE_DRAFT_FORM';
export const CLEAR_DRAFT_FORM = 'jora-employer/draft/CLEAR_DRAFT_FORM';

export const JOB_DRAFT_FORM = 'job';
export const BUSINESS_DRAFT_FORM = 'business';
